import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';

const MainLayout = ({ children, activeNavItem, title, searchPlaceholder, notifications }) => {
  const [syncStatus, setSyncStatus] = useState({
    lastSync: '2 min ago',
    pendingNotes: 3,
    knowledgeGraph: 'Up to date'
  });

  // This would normally fetch real status data
  useEffect(() => {
    const syncInterval = setInterval(() => {
      // In a real app, this would make an API call to get the latest sync status
      setSyncStatus(prevStatus => ({
        ...prevStatus,
        lastSync: Math.floor(Math.random() * 5) + 1 + ' min ago'
      }));
    }, 30000); // Update every 30 seconds

    return () => clearInterval(syncInterval);
  }, []);

  const handleSyncNow = () => {
    toast.info("Syncing with server...");
    // Simulate sync
    setTimeout(() => {
      setSyncStatus({
        lastSync: 'Just now',
        pendingNotes: Math.max(0, syncStatus.pendingNotes - 1),
        knowledgeGraph: 'Up to date'
      });
      toast.success("Sync completed successfully");
    }, 1500);
  };

  return (
    <div className="flex flex-col h-screen">
      <Header
        title={title}
        searchPlaceholder={searchPlaceholder}
        notifications={notifications}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar activeItem={activeNavItem} />
        <div className="flex-1 overflow-auto bg-gray-100">
          {children}
        </div>
      </div>
      <div 
        className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300 flex justify-between items-center"
        onClick={handleSyncNow}
        style={{cursor: 'pointer'}}
      >
        <div>
          Last sync: {syncStatus.lastSync} | {syncStatus.pendingNotes} notes pending | Knowledge graph: {syncStatus.knowledgeGraph}
        </div>
        <button 
          className="px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
          onClick={(e) => {
            e.stopPropagation();
            handleSyncNow();
          }}
        >
          Sync Now
        </button>
      </div>
    </div>
  );
};

export default MainLayout;